import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  menu: {
    display: "none",
    [theme.breakpoints.down('sm')]: {
      display: "block",
    },
  },
  footerHead: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "1rem",
    backgroundColor: 'transparent',
    fontWeight: 600,
    padding: "0.5rem 20rem",
    [theme.breakpoints.down('lg')]: {
      padding: "0.5rem 5rem",
    },
    [theme.breakpoints.down('sm')]: {
      padding: "0.5rem 1rem",
      display: "none",
    },
  },
  contactContainer: {
    color: theme.agentTheme.text.body_text_color,
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "&>span": {
      display: "flex",
      alignItems: "center",
    },
  },
  loginContainer: {
    color: theme.agentTheme.text.body_text_color,
  },

  logoImg: {
    height: "40px",
    width: "auto",
    cursor: "pointer",
  },
  menuIcon: {
    color: theme.agentTheme.text.link_text_color,
  },
  footerTail: {
    backgroundColor: theme?.agentTheme?.primary?.main,
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20rem",
    [theme.breakpoints.down('lg')]: {
      padding: "1rem 4rem",
      flexDirection: "column",
      gap: "1rem",
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor:'transparent',
      flexDirection: "row",
       justifyContent: "flex-start",
       padding:'1rem'
    },
  },
  navbar: {
    display: "flex",
    justifyContent: "center",
    margin:'auto',
    alignItems: "center",
    gap: "1.5rem",
    fontSize: "1rem",
    color: theme.agentTheme.text.link_text_color,
    [theme.breakpoints.down('sm')]: {
      display: "none",
    },
  },

  navItem: {
    color: "currentColor",
    fontWeight: 700,
    letterSpacing: "0.05rem",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
  },

  // mobile Drawer styling
  contentTextSideNavbar: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginRight: "50px",
    cursor: "pointer",
    margin: theme.spacing(1, 0, 1, 1),
    display: "flex",
  },

  navbarContentContainer: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    marginLeft: "16px",
    borderBottom: `0.5px solid ${theme.agentTheme.card.muted_foreground}`,
  },

  mobileNavDrawer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.agentTheme.card.main,
    height: "100vh",
    width: "100%",
    paddingTop: "5px",
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch",
  },

  closeBtn: {
    marginRight: "40px",
  },

  closeIcon: {
    color: theme.agentTheme.card.link_foreground,
  },

  usernameText: {
    color: theme.agentTheme.card.link_foreground,
    marginLeft: "8px",
  },
  loginButton: {
  background: theme.agentTheme.secondary.main,
  color: theme?.agentTheme?.secondary?.foreground,
  padding: "10px 26px",
  fontSize: "16px",
  fontWeight: 600,
  borderRadius: "30px",
  cursor: "pointer",
  textTransform: "none",
  transition: "0.3s",
  "&:hover": {
    background: theme.agentTheme.secondary.main,
  color: theme?.agentTheme?.secondary?.foreground,
  },
},

}));

export default useStyles;
